import './styles/main';

import './images/hipages-primary-logo-reversed.svg';



// WEBPACK FOOTER //
// ./footer/index.js